// components/OptimizedSupabaseImage.tsx

import Image, { type ImageProps } from 'next/image';
import React from 'react';

// Accept the raw `src` from Supabase and an `alt` tag,
// plus all other standard `next/image` props.
interface OptimizedSupabaseImageProps extends Omit<ImageProps, 'src'> {
  src: string | null | undefined;
  alt: string;
}

export function OptimizedSupabaseImage({ src, alt, ...props }: OptimizedSupabaseImageProps) {
  // Don't render anything if the src is missing.
  if (!src) {
    return null;
  }

  // Use the Next.js Image component to automatically handle optimization.
  // CRITICAL: You must provide `width`/`height` or `fill` for layout stability.
  // These can be passed down as props from Plasmic.
  return (
    <Image
      src={src}
      alt={alt}
      // Pass through all other props like width, height, sizes, className, fill, etc.
      {...props}
    />
  );
}